import gql from 'graphql-tag';

import { TeamMemberDetails } from '../fragments/team-members';

export const teamMemberCreate = gql`
  mutation teamMemberCreate($input: TeamMemberCreateInput!) {
    teamMemberCreate(input: $input) {
      team_member {
        ...TeamMemberDetails
      }
    }
  }
  ${TeamMemberDetails}
`;

export const teamMemberDelete = gql`
  mutation teamMemberDelete($input: TeamMemberDeleteInput!) {
    teamMemberDelete(input: $input) {
      success
    }
  }
`;

export const teamMemberInvitationAccept = gql`
  mutation teamMemberInvitationAccept(
    $input: TeamMemberInvitationAcceptInput!
  ) {
    teamMemberInvitationAccept(input: $input) {
      team_member {
        ...TeamMemberDetails
      }
    }
  }
  ${TeamMemberDetails}
`;

export const teamMemberLogin = gql`
  mutation teamMemberLogin($input: TeamMemberLoginInput!) {
    teamMemberLogin(input: $input) {
      success
      auth_token
    }
  }
`;

export const teamMemberPasswordReset = gql`
  mutation teamMemberPasswordReset($input: TeamMemberPasswordResetInput!) {
    teamMemberPasswordReset(input: $input) {
      success
    }
  }
`;

export const teamMemberPasswordResetRequest = gql`
  mutation teamMemberPasswordResetRequest(
    $input: TeamMemberPasswordResetRequestInput!
  ) {
    teamMemberPasswordResetRequest(input: $input) {
      success
    }
  }
`;
